import axios from '@axios'

export default {
  namespaced: true,
  state: {
    cidades: [],
  },
  getters: {
    getCidades: state => state.cidades,
  },
  mutations: {
    SET_CIDADES(state, payload) {
      state.cidades = payload
    },
  },
  actions: {
    GET_CIDADES({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/cidades')
          .then(response => {
            commit('SET_CIDADES', response.data.cidades)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
    GET_CIDADES_BY_CIDADE_NOME({ commit }, uf) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/cidades?q=${uf}`)
          .then(response => {
            commit('SET_CIDADES', response.data.cidades)
            resolve(response.data)
          })
          .catch(error => reject(error))
      })
    },
  },
}
